import React, { useState } from 'react';
import { TextField, Button, Box, Divider, Typography } from '@mui/material';
import { Google as GoogleIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../utils/supabase';

export default function LoginForm() {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    
    try {
      const { error } = await supabase.auth.signInWithPassword({
        email: formData.email,
        password: formData.password
      });
      
      if (error) throw error;
      navigate('/dashboard');
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleRegisterClick = () => {
    navigate('/register'); // Navigate to the /register route
  };

  const handleGoogleLogin = async () => {
    try {
      setLoading(true);
      setError(null);
      
      // Let's try without the explicit redirectTo to see if Supabase handles it better
      console.log('🔍 Attempting Google OAuth without explicit redirectTo');
      
      const { data, error } = await supabase.auth.signInWithOAuth({
        provider: 'google'
      });

      console.log('OAuth response data:', data);
      console.log('OAuth response error:', error);

      if (error) {
        console.error('Google login error:', error);
        setError(error.message);
        setLoading(false);
      }
    } catch (err) {
      console.error('Unexpected error:', err);
      setError('An unexpected error occurred during Google login');
      setLoading(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <TextField
        label="Email"
        name="email"
        type="email"
        value={formData.email}
        onChange={handleChange}
        required
      />
      <TextField
        label="Password"
        name="password"
        type="password"
        value={formData.password}
        onChange={handleChange}
        required
      />
      {error && <Box color="error.main">{error}</Box>}
      
      <Button type="submit" variant="contained" disabled={loading}>
        {loading ? 'Logging in...' : 'Login'}
      </Button>
      
      <Divider sx={{ my: 2 }}>
        <Typography variant="body2" color="text.secondary">
          OR
        </Typography>
      </Divider>

      <Button
        fullWidth
        variant="outlined"
        onClick={handleGoogleLogin}
        disabled={loading}
        sx={{ 
          py: 1.5,
          border: '2px solid #4285f4',
          color: '#4285f4',
          '&:hover': {
            backgroundColor: '#4285f4',
            color: 'white',
            border: '2px solid #4285f4'
          },
          '&:disabled': {
            opacity: 0.6
          }
        }}
        startIcon={<GoogleIcon />}
      >
        {loading ? 'Connecting...' : 'Continue with Google'}
      </Button>
      
      <Button type="button" variant="text" onClick={handleRegisterClick} disabled={loading}>
        Don't have an account? Register
      </Button>
    </Box>
  );
}
